import ApiService from "./api.service";
 
const SportTypeService = {
    GetAll(lang, dateOfBirth, genderId, agecategoryid, sporttypecategoryid, isSeasonDoc, initiativtypeid, isonlineregistration){
        if (agecategoryid === null || agecategoryid === undefined) {
            agecategoryid = 0;
        }
        if (sporttypecategoryid === null || sporttypecategoryid === undefined) {
            sporttypecategoryid = 0;
        }
        if (dateOfBirth === 0 || dateOfBirth === undefined || dateOfBirth === null) {
            dateOfBirth = '';
        }
        if (initiativtypeid === 0 || initiativtypeid === undefined || initiativtypeid === null) {
            initiativtypeid = '';
        }
        if (isSeasonDoc === null || isSeasonDoc === undefined) {
            isSeasonDoc = false;
          }
          if (isonlineregistration == null || isonlineregistration === undefined|| isonlineregistration === '') {
            isonlineregistration = false;
          }
        return ApiService.get(`/SportType/GetAll?lang=${lang}&dateOfBirth=${dateOfBirth}&genderId=${genderId}&agecategoryid=${agecategoryid}&sporttypecategoryid=${sporttypecategoryid}&isSeasonDoc=${isSeasonDoc}&initiativtypeid=${initiativtypeid}&isonlineregistration=${isonlineregistration}`)
    },
}
export default SportTypeService